import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
    template: `<div>This component requires extending</div>`
})
export class ScaffoldComponent implements OnInit {
    @Input() public preContent: TemplateRef<any> = null;
    @Input() public postContent: TemplateRef<any> = null;

    constructor() { }

    ngOnInit(): void { }
}
